export default __webpack_public_path__ + "static/media/blue_calendar.d270568d.svg";